import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, exhaustMap, switchMap } from 'rxjs/operators';

import { InventoryService } from '@inventory/inventory.service';
import * as inventoryActions from '@inventory/store/inventory.actions';
import * as tempdataActions from '@store/tempdata/tempdata.actions';

@Injectable()
export class InventoryEffects {
  constructor(private actions$: Actions, private inventoryService: InventoryService) {}

  invSumRequestData = createEffect(() => {
    return this.actions$.pipe(
      ofType<inventoryActions.InvSumRequestData>(inventoryActions.INV_SUM_REQUEST_DATA),
      switchMap(({ filter }) => this.inventoryService.getInventoryFcpiByFilter(filter)),
      concatMap((rowdata) => [new tempdataActions.InvSumSetGridData(rowdata)])
    );
  });

  invDtlRequestData = createEffect(() => {
    return this.actions$.pipe(
      ofType<inventoryActions.InvDtlRequestData>(inventoryActions.INV_DTL_REQUEST_DATA),
      switchMap(({ filter }) => this.inventoryService.getInventoryItemDetail(filter.facility, filter.item)),
      concatMap((rowdata) => [new tempdataActions.InvDtlSetGridData(rowdata)])
    );
  });


  invItemLotRequiredRequestData = createEffect(() => {
    return this.actions$.pipe(
      ofType<inventoryActions.InvItemLotReuiredRequestData>(inventoryActions.INV_ITEM_LOT_REQ_DATA),
      exhaustMap(({ item }) => this.inventoryService.getInventoryItemLotRequiredVal(item)),
      concatMap((lotrequiredItem) => {
        return [new inventoryActions.InvItemLotReuiredRequestDataSuccess(lotrequiredItem)];
      })
    );
  });
  
  invLotRequestData = createEffect(() => {
    return this.actions$.pipe(
      ofType<inventoryActions.InvLotRequestData>(inventoryActions.INV_LOT_REQUEST_DATA),
      switchMap(({ data }) => this.inventoryService.getInventoryItemLot(data)),
      concatMap((rowdata) => [new tempdataActions.InvLotSetGridData(rowdata)])
    );
  });
}
